import React from 'react';
import { Button } from '@/Components/ui';

interface DashboardChangelogCardProps {
  hasChangelog: boolean;
  isLoading: boolean;
  onOpen: () => void;
}

export default function DashboardChangelogCard({ hasChangelog, isLoading, onOpen }: DashboardChangelogCardProps) {
  const isDisabled = isLoading || !hasChangelog;
  const buttonLabel = isLoading ? '불러오는 중' : hasChangelog ? '변경사항 보기' : '변경사항 없음';

  return (
    <div className="col-xl-12">
      <div className="card crm-widget">
        <div className="card-body" style={{ padding: '26px' }}>
          <div className="d-flex flex-column gap-3">
            <div style={{ fontSize: '18px', fontWeight: '600', color: '#4B465C', width: '100%' }}>CRM 변경사항</div>
            <div style={{ fontSize: '15px', color: 'rgba(75, 70, 92, 1)' }}>
              닫은 변경사항도 다시 확인할 수 있습니다.
            </div>
            <div>
              <Button color="outline-primary" disabled={isDisabled} onClick={onOpen}>
                <i className="bx bx-history me-1" aria-hidden="true" />
                {buttonLabel}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
